/* Source: /home/sidsolaiyappan/skooch_ai/scheduler/scheduler_calendar.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function SchedulerWeekNav(weekLabel, onPrev, onNext, schZoom, applyZoom, rightSlot) {
  let _zoomOutDisabled = (schZoom <= 0);
  let _zoomInDisabled = (schZoom >= 4);
  return __jacJsx("div", {"style": {"display": "flex", "justifyContent": "space-between", "alignItems": "center", "padding": "0.4rem 0.6rem", "borderBottom": "1px solid var(--border)"}}, [__jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onPrev([]);
  }, "title": "Previous week", "aria-label": "Previous week", "style": {"minWidth": "42px"}}, ["<"]), __jacJsx("div", {"style": {"fontSize": "0.85rem", "fontWeight": "700", "textAlign": "center", "flex": "1"}}, [weekLabel]), __jacJsx("div", {"style": {"display": "inline-flex", "alignItems": "center", "gap": "0.4rem"}}, [__jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": () => {
    onNext([]);
  }, "title": "Next week", "aria-label": "Next week", "style": {"minWidth": "42px"}}, [">"]), rightSlot, __jacJsx("div", {"className": "sch-zoom-controls"}, [__jacJsx("button", {"className": ("sch-zoom-btn" + (_zoomOutDisabled ? " sch-zoom-btn-disabled" : "")), "onClick": () => {
    let _next = (schZoom - 1);
    if ((_next >= 0)) {
      applyZoom(_next);
    }
  }, "title": "Zoom out", "aria-label": "Zoom out"}, ["\ud83d\udd0d\u2212"]), __jacJsx("button", {"className": ("sch-zoom-btn" + (_zoomInDisabled ? " sch-zoom-btn-disabled" : "")), "onClick": () => {
    let _next = (schZoom + 1);
    if ((_next <= 4)) {
      applyZoom(_next);
    }
  }, "title": "Zoom in", "aria-label": "Zoom in"}, ["\ud83d\udd0d+"])])])]);
}
export {SchedulerWeekNav};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:SchedulerWeekNav": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=scheduler_calendar.js.map
